import { Modal } from "./modal";
import localScaleManager from "../../helpers/LocalScaleManager";
import Button from "./objects/button";
import { tweenConfigs } from "../../helpers/tweensConfigs";

export default class Notice extends Modal {
  constructor(scene, table) {
    super(scene, table);
    this.scene = scene;
    this.table = table;
    this.isShowing = false;
    this.bg = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "notice-bg")
      .setOrigin(0);
    // this.bg = this.scene.add.sprite(0, 0, 'notice-bg').setOrigin(0);
    this.table.poolArray.push(this.bg);

    this.title = this.scene.add.bitmapText(0, 0, "HelveticaNeue", "Notice");
    this.title.setData("width", this.title.width);
    this.title.setData("height", this.title.height);
    this.table.poolArray.push(this.title);

    this.text = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeue",
      "".padStart(45, "a")
    );
    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);
    this.table.poolArray.push(this.text);

    // this.button = this.scene.add.image(0, 0, this.scene.atlasTexture, 'reserve-modal-ok').setOrigin(0);
    this.ok = new Button(this.scene, "ok-btn", true, this.table);
    this.cancel = new Button(this.scene, "cancel-btn", true, this.table);
    this.ok.on("pointerup", this.onOkClick, this); //D
    this.cancel.on("pointerup", this.onCancelClick, this); //D

    this.children = this.scene.add.group();
    this.children.addMultiple([
      this.closeButton,
      this.text,
      this.title,
      this.ok,
      this.cancel,
      this.bg,
    ]);
    this.table.poolArray.push(this.children);
    Phaser.Actions.SetDepth(this.children.getChildren(), 101);
    this.closeButton.setDepth(102); /* close button */
    Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
    this.closeButton.on("pointerup", this.onCloseClick, this); //D
    this.overlay.on("pointerdown", this.hide, this);
    this.allowShow = true;
  }
  async onCloseClick() {
    this.closeButton.onClick(() => {
      this.closeButton.disableInteractive();
      this.hide().then(() => this.closeButton.enableInteractive());
    });
  }
  async onCancelClick() {
    this.cancel.onClick(() => {
      this.cancel.disableInteractive();
      this.hide().then(() => this.cancel.enableInteractive());
    });
  }
  async onOkClick() {
    this.ok.onClick(() => {
      this.ok.disableInteractive();
      this.okCallBackFunc();
      if (!this.table.removed) {
        this.hide().then(() => {
          this.ok.enableInteractive();
        });
      }
    });
  }

  okCallBackFunc() {}

  hide() {
    return new Promise((resolve, reject) => {
      this.scene.tweens.add({
        targets: this.children.getChildren(),
        duration: tweenConfigs.modal.hide.duration,
        ease: tweenConfigs.modal.hide.ease,
        alpha: 0,
        onComplete: () => {
          Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
          this.isShowing = false;
          this.allowShow = true;
          resolve();
        },
      });
      this.modalHide();
    });
  }

  /**
   * @param msg {string}
   * @param onOkClicked {function}
   */
  show(msg, onOkClicked) {
    this.okCallBackFunc = onOkClicked;
    if (this.allowShow) {
      this.allowShow = false;
      this.updateMsg(msg);
      this.scene.getVisitedTable().buttonManager.raiseBtn.hideRaiseMenu();
      // this.scene.getVisitedTable().buttonManager.betBtn.hideRaiseMenu();
      const newArray = this.children
        .getChildren()
        .filter((item) => item !== this.bg);
      this.scene.tweens.add({
        targets: newArray,
        // delay: 200,
        duration: tweenConfigs.modal.show.duration,
        ease: tweenConfigs.modal.show.ease,
        alpha: 1,
        onComplete: () => {
          Phaser.Actions.SetAlpha(newArray, 1);
          this.isShowing = true;
        },
      });
      this.scene.tweens.add({
        targets: this.bg,
        // delay: 200,
        duration: tweenConfigs.modal.show.duration,
        ease: tweenConfigs.modal.show.ease,
        alpha: 0.7,
        onComplete: () => {
          this.bg.setAlpha(0.7);
        },
      });
      this.modalShow();
    }
  }
  updateMsg(msg) {
    this.text.setText(msg);
    this.text.setX(this.bg.x + (this.bg.displayWidth - this.text.width) / 2);
  }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    const bgSize = width;
    localScaleManager.scaleSprite(this.bg, bgSize, bgSize, 0, 1, true);
    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + (height - this.bg.displayHeight) / 2
    );
    super.positionControls(this.bg.x, this.bg.y, this.bg.displayWidth);

    const titleSize = width * 0.18;
    localScaleManager.scaleBitMapText(
      this.title,
      titleSize,
      titleSize,
      Math.min(this.title.width, this.title.height) * 0.2,
      1,
      false
    );
    this.title.setPosition(
      initX + (width - this.title.width) / 2,
      initY + height / 2.8
    );

    const textSize = this.bg.displayWidth * 0.9;
    localScaleManager.scaleBitMapText(
      this.text,
      textSize,
      height / 10,
      0,
      1,
      false
    );
    this.text.setPosition(
      this.bg.x + (this.bg.displayWidth - this.text.width) / 2,
      this.bg.y + this.bg.displayHeight / 2 - this.text.height
    );

    const okSize = width / 3.5;
    const okScale = localScaleManager.scaleSprite(
      this.ok,
      okSize,
      okSize,
      0,
      1,
      true
    );
    localScaleManager.scaleSpriteTo(this.cancel, okScale);
    this.ok.setPosition(
      initX + (width - this.ok.displayWidth) / 2 - this.ok.displayWidth / 30,
      this.bg.y + this.bg.displayHeight - this.ok.displayHeight * 1.5
    );
    this.cancel.setPosition(
      initX + (width + this.ok.displayWidth) / 2 + this.ok.displayWidth / 30,
      this.bg.y + this.bg.displayHeight - this.ok.displayHeight * 1.5
    );
  }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + (height - this.bg.displayHeight) / 2
    );
    super.reposition(this.bg.x, this.bg.y, this.bg.displayWidth);

    this.title.setPosition(
      initX + (width - this.title.width) / 2,
      initY + height / 2.8
    );

    this.text.setPosition(
      this.bg.x + (this.bg.displayWidth - this.text.width) / 2,
      this.bg.y + this.bg.displayHeight / 2 - this.text.height
    );
    this.ok.setPosition(
      initX + (width - this.ok.displayWidth) / 2 - this.ok.displayWidth / 30,
      this.bg.y + this.bg.displayHeight - this.ok.displayHeight * 1.5
    );
    this.cancel.setPosition(
      initX + (width + this.ok.displayWidth) / 2 + this.ok.displayWidth / 30,
      this.bg.y + this.bg.displayHeight - this.ok.displayHeight * 1.5
    );
  }
  remove() {
    super.remove();
    this.bg.destroy();
    this.title.destroy();
    this.text.destroy();
    this.ok.destroy();
    this.cancel.destroy();
  }
}
